require(
      "!../../node_modules/gatsby-module-loader/patch.js"
    );
    module.exports = function(cb) { return require.ensure([], function(_, error) {
        if (error) {
          console.log('bundle loading error', error)
          cb(true)
        } else {
          cb(null, function() { return require("!!../../node_modules/json-loader/index.js!./blog-scion-5-release-announcement.json") })
        }
      }, "path---blog-scion-5-release-announcement");
     }
    


//////////////////
// WEBPACK FOOTER
// ./~/gatsby-module-loader?name=path---blog-scion-5-release-announcement!./.cache/json/blog-scion-5-release-announcement.json
// module id = 757
// module chunks = 231608221292675